import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';

const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: 'auth/client'},
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/admin/admin.module').then(module => module.AdminModule)
  },
  {
    path: 'auth',
    component: AuthComponent,
    loadChildren: () => import('./pages/auth/auth.module').then(module => module.AuthModule)
  },
  { path: 'auth/client', loadChildren: () => import('./client/client.module').then(m => m.ClientModule) },
  {
    path: 'app/leilao',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/app/leilao/leilao.module').then(m => m.LeilaoModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
